export default {
  cake: {
    // TODO MY TOKEN (search replace 1)
    137: '0x252656AdC9E22C697Ce6c08cA9065FBEe5E394e7',
  },
  masterChef: {
    // TODO MY Masterchef (search replace 2)
    137: '0xeA038416Ed234593960704ddeD73B78f7D578AA0',
  },
  wmatic: {
    // WMATIC
    137: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
  },
  multiCall: {
    137: '0x941dC4660E9eF36D48e7e78e797bBc910131B0f2',
  },
  usdc: {
    // USDC
    137: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
  },
}
